module.exports = __webpack_public_path__ + "media/images/lb/336-929bbb41b19fd716048bcc8f0412dd74.svg";